import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'align': [] }],
    ['blockquote'],
    ['clean']
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'align', 'blockquote'
];

export function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="rich-text-editor" data-testid="rich-text-editor">
      <style>{`
        .rich-text-editor .ql-toolbar {
          background: #1A1A1A;
          border-color: #333333 !important;
          border-radius: 4px 4px 0 0;
        }
        .rich-text-editor .ql-toolbar .ql-stroke { stroke: #999999; }
        .rich-text-editor .ql-toolbar .ql-fill { fill: #999999; }
        .rich-text-editor .ql-toolbar .ql-picker-label { color: #999999; }
        .rich-text-editor .ql-toolbar button:hover .ql-stroke,
        .rich-text-editor .ql-toolbar .ql-active .ql-stroke { stroke: #22C55E; }
        .rich-text-editor .ql-toolbar button:hover .ql-fill,
        .rich-text-editor .ql-toolbar .ql-active .ql-fill { fill: #22C55E; }
        .rich-text-editor .ql-toolbar .ql-picker-options {
          background: #1A1A1A;
          border-color: #333333;
        }
        .rich-text-editor .ql-toolbar .ql-picker-item { color: #999999; }
        .rich-text-editor .ql-toolbar .ql-picker-item:hover { color: #22C55E; }
        .rich-text-editor .ql-container {
          background: #111111;
          border-color: #333333 !important;
          border-radius: 0 0 4px 4px;
          color: #ffffff;
          font-family: inherit;
          min-height: 120px;
        }
        .rich-text-editor .ql-editor {
          min-height: 120px;
          font-size: 14px;
          line-height: 1.6;
        }
        .rich-text-editor .ql-editor.ql-blank::before {
          color: #666666;
          font-style: normal;
        }
        .rich-text-editor .ql-editor h1 { color: #ffffff; font-size: 1.5em; }
        .rich-text-editor .ql-editor h2 { color: #ffffff; font-size: 1.3em; }
        .rich-text-editor .ql-editor h3 { color: #ffffff; font-size: 1.1em; }
        .rich-text-editor .ql-editor blockquote {
          border-left: 3px solid #22C55E;
          padding-left: 12px;
          color: #999999;
        }
        .rich-text-editor .ql-editor ul, .rich-text-editor .ql-editor ol { padding-left: 1.5em; }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'Describe what you\'re offering...'}
      />
    </div>
  );
}
